import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.2 7.2q-1.5 0-2.55-1.05T3.6 3.6t1.05-2.55T7.2 0t2.55 1.05T10.8 3.6 9.75 6.15 7.2 7.2M0 12.6V12q0-.574.313-1.087a2.66 2.66 0 0 1 .862-.863c.913-.532 1.89-.943 2.908-1.225a11.65 11.65 0 0 1 6.23 0q1.538.426 2.912 1.225.55.325.863.85T14.4 12v.6q0 .742-.529 1.272a1.74 1.74 0 0 1-1.272.528H1.793q-.743 0-1.268-.528A1.74 1.74 0 0 1 0 12.6m1.8 0h10.8V12a.4.4 0 0 0-.075-.235.5.5 0 0 0-.2-.165 9.4 9.4 0 0 0-2.45-1.05A10.3 10.3 0 0 0 7.2 10.2q-1.374 0-2.675.35a9.4 9.4 0 0 0-2.45 1.05 1.3 1.3 0 0 0-.2.193A.32.32 0 0 0 1.8 12zm5.405-7.2q.745 0 1.27-.53T9 3.595t-.53-1.27A1.75 1.75 0 0 0 7.195 1.8q-.744 0-1.27.53A1.75 1.75 0 0 0 5.4 3.606q0 .745.53 1.27.532.525 1.275.524"
    }, null, -1)
  ]))]))
}
export default { render: render }